const NUMBER_FORMATTER = new Intl.NumberFormat('de-DE')

export const parseDisplayNumber = (value?: string | number | null): string => {
  if (value === undefined || value === null) {
    return ''
  }

  return String(value).replace(/[^\d-]/g, '')
}

export const formatDisplayNumber = (value?: string | number | null): string => {
  if (value === undefined || value === null || value === '') {
    return ''
  }

  const normalized =
    typeof value === 'number'
      ? value
      : Number.parseFloat(parseDisplayNumber(value))

  if (!Number.isFinite(normalized)) {
    return String(value)
  }

  return NUMBER_FORMATTER.format(normalized)
}
